export interface RolePermission {
  roleId?: number;
  permissionId?: number;
  permissionName?: string;
  accessGranted?: boolean;
}

export enum PermissionId {
  ManageBilling = 7,
}
